module.exports = __webpack_public_path__ + "img/loading.4c641500.svg";